import React from 'react';
import { CartoonPortrait } from './CartoonPortrait';
interface FigureProps {
  className?: string;
}
export function CabooseFigure({
  className = ''
}: FigureProps) {
  return <CartoonPortrait className={className} label="Cartoon portrait of the caboose child, the late and warmly received arrival" disc="#F2A05A" skin="#F7D3AE" skinShade="#E8BC91" hair="#8C3B12" shirt="#FBF7F0" hairStyle="topKnot" mouth="grin" motif="heat" tilt={-3} data-id="element-1" data-mp="17o89rguv7jjl" />;
}